var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slots.content || _vm.val)?_c('div',[_c('label',{class:['display-label', 'mb-2', { hasError: _vm.errors && _vm.errors.length }]},[_vm._v(_vm._s(_vm.label))]),(_vm.val)?_c('FormLabel',{attrs:{"label":_vm.val,"bold":""}}):_vm._t("content"),_c('ErrorMessages',{attrs:{"errors":_vm.errors}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }